import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Button from 'components/form/Button.component';
import Icon from 'components/generic/Icon.component';
import ResponsiveBox from 'components/generic/ResponsiveBox.component';
import PURCHASE_VARIANTS from 'constants/sms/purchase.const';
import useTip from 'hooks/useTip.hook';
import { useTranslation } from 'providers/GILT.provider';
import { useCurrentSalonId } from 'providers/SalonBasicInfo.provider';
import { selectClientCommsSmsCreditsAvailable } from 'selectors/clientCommunications.selectors';
import selectEffectiveUserRole from 'selectors/selectEffectiveUserRole';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';

import { purchaseSmsBundle } from 'clientCommunications/actions';
import PurchaseSmsCreditDialog from 'clientCommunications/components/Clients/PurchaseSmsCreditDialog';

import CN from './SmsBuyButton.module.scss';

export const SmsBuyButton = ({ tag }) => {
  const salonId = useCurrentSalonId();
  const { t } = useTranslation();
  const { val: renderSmsModal, tip: toggleSmsModal } = useTip(false);

  const dispatch = useDispatch();
  const permission = useSelector(selectEffectiveUserRole);
  const smsCredits = useSelector(selectClientCommsSmsCreditsAvailable);
  const smsError = useSelector((state) => state.clientCommunications.errorMessage);
  const isSmsFetching = useSelector((state) => state.clientCommunications.isFetching);

  const onPurchase = useCallback((...args) => dispatch(purchaseSmsBundle(...args)), [dispatch]);

  return (
    <div className={CN.component} data-bem="SmsBuyButton" data-tag={fromAnyToTrimmed(tag)}>
      <Button data-bem="SmsBuyButton__button" className={CN.button} onClick={toggleSmsModal}>
        <Icon variant="smsBubble" selected width="xl" />
        <ResponsiveBox.Desktop>
          <div className={CN.smsText}>
            {smsCredits} {t('composite.purchaseSmsCreditDialog.credits')}
          </div>
        </ResponsiveBox.Desktop>
      </Button>

      {renderSmsModal && (
        <PurchaseSmsCreditDialog
          closePopup={toggleSmsModal}
          // FIXME
          // gotoBilling={() =>
          //   nav.push({
          //     pathname: linkTo({
          //       pattern: LINK.billing,
          //       salonId,
          //     }),
          //   })
          // }
          gotoBilling={() => {
            window.location.hash = `#/salon/${salonId}/settings/billing`;
          }}
          purchaseSmsBundle={onPurchase}
          salonId={salonId}
          errorMessage={smsError}
          isFetching={isSmsFetching}
          sms_credits_available={smsCredits}
          permission={permission}
          variant={PURCHASE_VARIANTS.lowCredit}
          variantButton="lowCredit"
        />
      )}
    </div>
  );
};
